import { render, staticRenderFns } from "./Photos.vue?vue&type=template&id=7d483d92&scoped=true"
import script from "./Photos.vue?vue&type=script&lang=ts"
export * from "./Photos.vue?vue&type=script&lang=ts"
import style0 from "./Photos.vue?vue&type=style&index=0&id=7d483d92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d483d92",
  null
  
)

export default component.exports